import { createGetChannel, createPostChannel } from '../utils/apis/requestRX';
import { Fetch, ResponseData, ResponseList } from '../utils/apis/typeRX';

//登录参数
export interface LoginParams {
    account: string;
    password: string | boolean;
}

//登录
export const login: Fetch<LoginParams, ResponseData<string>> = createPostChannel('/api/reexuan-blockchain-service/explorer/login');

